import { forwardRef, type Ref, type SVGProps } from "react";
const IconCheckedBoxOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M25 17v8H7V7h10V5H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-8z" /><path fill="currentColor" d="M16 21c-.2 0-.5-.1-.6-.2l-6-5c-.4-.4-.5-1-.1-1.4s1-.5 1.4-.1l5.2 4.3 9.4-13.1c.3-.4.9-.6 1.4-.2.4.3.6.9.2 1.4l-10 14c-.2.2-.4.4-.7.4z" /></svg>;
const ForwardRef = forwardRef(IconCheckedBoxOutlineSVG);
ForwardRef.displayName = "IconCheckedBoxOutline";
export { ForwardRef as IconCheckedBoxOutline };